import { css } from 'styled-components';

const fontWeight = css `
  font-weight: ${props => props.$fontWeight};
`;

export { fontWeight };
//# sourceMappingURL=fontWeight.js.map
